(function(){
  var targets=['efe0c083-26fe-4434-961f-87376025098b','1e7795fc-fa5c-47ba-803a-4796c893dd27','nov_img_text_XGp3NN','nov_img_text_KbhHDK'];
  function removeLegacy(){
    targets.forEach(function(key){
      document.querySelectorAll('[id*="'+key+'"]').forEach(function(el){
        var section=el.closest('.shopify-section') || el;
        if(section && section.parentNode){ section.parentNode.removeChild(section); }
      });
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',removeLegacy);}else{removeLegacy();}
  window.addEventListener('load',removeLegacy);
  setTimeout(removeLegacy,300);
  setTimeout(removeLegacy,1200);
})();
